export interface GroupedItem {
    id: string
    name: string
    type: string
    count: number
    price: number
    totalPrice: number
    originalData: any
}

export function groupByNameEnhancedHappy(
    options: any[],
    type: string,
    optionId: number
): GroupedItem[] {
    const grouped: Record<string, GroupedItem> = {}

    options.forEach((value) => {
        const name = value.option_value_name
        if (!grouped[name]) {
            grouped[name] = {
                id: `${type}-${optionId}-${name}`,
                name: name,
                type: type,
                count: 0,
                price: Number(value.option_value_price) || 0,
                totalPrice: 0,
                originalData: value
            }
        }

        grouped[name].count++
        grouped[name].totalPrice = grouped[name].price * grouped[name].count
    })

    return Object.values(grouped)
}